import React, { useState } from "react";
import styles from "./MaterialsDetail.module.css";
import ModalQ from "../../../components/TableBionovaQ/ModalQ/ModalQ";
import CheckBoxQ from "../../../components/FormComponents/CheckBoxQ/CheckBoxQ";
import t from "../../../utils/translation";
import ImageModal from "../../../components/ImageModal/ImageModal";

const MaterialsDetail = ({ materialData, t, locale, handleClose, open }) => {

  const [isModalOpen, setModalOpen] = useState(false);
  
  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleImageClick = () => {
    setModalOpen(true);
  };
  return (
    <ModalQ handleClose={handleClose} open={open} title={"Materials Detail"}>
      <div className={styles.detailContainer}>
        <div className={styles.inputGroup}>
          <div className={styles.detailItem}>
            <label className={styles.detailLabel}>
              {t("NameSpan") || "Name"}:
            </label>
            <div className={styles.detailValue}>
              {materialData.materialName || "-"}
            </div>
          </div>
          <div className={styles.detailItem}>
            <label className={styles.detailLabel}>
              {t("BlankEntry92") || "Material Type"}:
            </label>
            <div className={styles.detailValue}>
              {materialData.materialTypeName || "-"}
            </div>
          </div>
        </div>

        <div className={styles.inputGroup}>
          <div className={styles.detailItem}>
            <label className={styles.detailLabel}>
              {t("SerialSpan", locale) || "Serial"}:
            </label>
            <div className={styles.detailValue}>
              {materialData.materialSerial || "-"}
            </div>
          </div>
          <div className={styles.detailItem}>
            <label className={styles.detailLabel}>
              {t("BlankEntry98") || "Suggested Method"}:
            </label>
            <div className={styles.detailValue}>
              {materialData.methodName || "-"}
            </div>
          </div>
        </div>
        <div className={styles.inputGroup}>
          <div 
          style={{ 
            marginTop: "20px", 
            display: "flex", 
            alignItems: "center", 
            gap: "8px",
            width: "48%",
            position: "relative"
            }}>
          <CheckBoxQ
            checked={materialData.isEndoscope}
            disabled={true}
            label={t("BlankEntry94") || "Is Endoscope/Cannulated"}
          />
          <CheckBoxQ
            checked={materialData.isImplant}
            disabled={true}
            label={t("BlankEntry93") || "Is Implant"}
          />
          </div>
           <div className={styles.detailItem}>
            <label className={styles.detailLabel}>
              {t("ObservationSpan")  || "Observations"}:
            </label>
            <div className={styles.detailValue}>
              {materialData.observations || "-"}
            </div>
          </div>
        </div>

        <div className={styles.inputGroup}>
          <div className={styles.detailItem}>
            <label className={styles.detailLabel}>
              {t("BlankEntry95")  || "Number of Cycles"}:
            </label>
            <div className={styles.detailValue}>
              {materialData.cyclesWarning || "-"}
            </div>
          </div>
          {materialData.materialImageLink && (
          <div className={styles.detailItem}>
            <div className={styles.imageContainer}>
              <p className={styles.detailLabel}>{t("ImageSpan" || "Image")}</p>
              <img src={materialData.materialImageLink} onClick={handleImageClick} />
            </div>
            {isModalOpen && (
            <ImageModal
              imageSrc={materialData.materialImageLink}
              onClose={handleCloseModal}
            />
          )}
          </div>
        )}
        </div>

      </div>
    </ModalQ>
  );
};

export default MaterialsDetail;
